import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import {
  GET_HORSE_RACE_SELECTED_HORSES,
  GET_HORSE_RACE_SELECTED_HORSES_SUCCESS,
  GET_HORSE_RACE_SELECTED_HORSES_FAILURE,
} from 'Store/constants';
import { catchTJKError } from 'Utils/catchTJKError';
import { hippodromesMapper, betDetailsMapper } from 'Utils/horseRacesNameMapper';
import ProjectConfig from 'ProjectConfig';

export const getHorseCardHorses = (raceDate, hippodromeKey, relatedRaceNo, akey, cid) => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_SELECTED_HORSES,
    });

    const date = new Date(raceDate).getTime();
    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/v2';
    const hippodromeRes = await axios.get(apiUrl, { params: { raceDate: date } });

    catchTJKError(hippodromeRes.data);

    const hippodromePayload = hippodromesMapper(hippodromeRes.data.body);

    const relatedHippodrome = hippodromePayload.find(h => h.key === hippodromeKey);


    const betTypeId = 1; // Ganyan oyun tipi için betTypeId.
    const params = cid ?  { cardId: cid, betTypeId, selectedRace: relatedRaceNo } : { akey: akey?.toUpperCase(), betTypeId, selectedRace: relatedRaceNo, raceDate: date };

    const api = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/bets/races/v2';
    const racesRes = await axios.get(
      api, { params });
    const racesPayload = betDetailsMapper(racesRes.data.body);

    catchTJKError(racesRes.data);
    dispatch({
      type: GET_HORSE_RACE_SELECTED_HORSES_SUCCESS,
      payload: { selectedHorses: racesPayload.legs[0].horseDetail, relatedHippodrome }
    });

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_SELECTED_HORSES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};
